import React from 'react';
import CannyIcon from '../../../public/assets/icons/canny.svg';
import DiscordIcon from '../../../public/assets/icons/discord.svg';
import TwitterIcon from '../../../public/assets/icons/twitter.svg';
import { DRIFT_DISCORD_URL } from '../../constants/constants';

export type SocialIconType = 'twitter' | 'discord' | 'canny';

interface Props {
	type: SocialIconType;
	className?: string;
}

const socialLinks = {
	twitter: {
		href: 'https://twitter.com/DriftProtocol',
		icon: <TwitterIcon />,
	},
	discord: {
		href: DRIFT_DISCORD_URL,
		icon: <DiscordIcon />,
	},
	canny: {
		href: 'https://drifttrade.canny.io/product-feedback',
		icon: <CannyIcon />,
	},
};

// this component controls the color of the svg through the fill=currentColor attribute
// the svg needs the fill=currentColor property to be able to be styled
// then you can control the color by passing a color through the color css property
const SocialIcon = ({ type, className = '' }: Props) => {
	const { href, icon } = socialLinks[type];
	return (
		<a href={href} target="_blank" rel="noreferrer noopener">
			<div className={className}>{icon}</div>
		</a>
	);
};

export default SocialIcon;
